var addressLookupMixin = {
    data: function () {
        return {
            showFindAddress: true,
            showNoResults: false,
            showAddressForm: false,
            showEnterAddressManually: true,
            addressLookupId: 0,
            addressLookup: '',
            addressLookupListSelect: [],
            addressApiError: false,
            isFindingAddress: false,
            address: {
                companyName: null,
                line1: null,
                line2: null,
                line3: null,
                city: null,
                state: null,
                postalCode: null,
                countryId: null
            }
        }
    },
    mounted: function () {
        const vm = this;
        vm.$nextTick(function () {
            if (vm.address.addressId > 0) {
                vm.enterAddressManually();
            }
        });
    },
    methods: {
        enterAddressManually: function () {
            const vm = this;
            vm.showAddressForm = true;
            vm.showEnterAddressManually = false;
        },
        findAddresses: function (container = "") {
            const vm = this;

            if (vm.isFindingAddress) {
                return;
            }

            var url = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
            var params = '';
            params += "&Key=" + encodeURIComponent(GLOBAL.LOQATEAPIKEY);
            params += "&Text=" + encodeURIComponent(vm.addressLookup);

            if (container !== null) {
                params += "&Container=" + encodeURIComponent(container);
            }

            params += "&IsMiddleware=" + encodeURIComponent("True");
            params += "&Countries=" + encodeURIComponent("GB");

            vm.isFindingAddress = true;
            axios.post(url, params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(function (response) {
                    if (!response) {
                        vm.enterAddressManually();
                        vm.addressApiError = true;
                        vm.isFindingAddress = false;
                        return;
                    }

                    vm.isFindingAddress = false;

                    var data = response.data;

                    if (data.Items.length) {
                        vm.showNoResults = false;

                        if (data.Items[0].Type !== 'Address') {
                            vm.findAddresses(data.Items[0].Id);
                            return;
                        }

                        vm.addressLookupListSelect = data.Items;
                        if (vm.addressLookupListSelect.length === 1) {
                            vm.addressLookupId = vm.addressLookupListSelect[0].Id;
                            vm.selectAddress();
                        }
                        else {
                            vm.addressLookupId = 0;
                        }
                    } else {
                        vm.showNoResults = true;
                        vm.enterAddressManually();
                    }
                })
                .catch(function () {
                    vm.enterAddressManually();
                    vm.addressApiError = true;
                    vm.isFindingAddress = false;
                });
        },
        selectAddress: function () {
            const vm = this;

            if (vm.addressLookupId == 0) {
                return;
            }

            vm.validateRecaptchaRetrieve().then(function (response) {
                if (!response) {
                    vm.enterAddressManually();
                    vm.addressApiError = true;
                    return;
                }

                var url = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws';
                var params = '';
                params += "&Key=" + encodeURIComponent(GLOBAL.LOQATEAPIKEY);
                params += "&Id=" + encodeURIComponent(vm.addressLookupId);

                axios.post(url, params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(function (response) {
                        var data = response.data;

                        if (data.Items.length === 1 && typeof (data.Items[0].Error) !== "undefined") {
                            vm.addressApiError = true;
                            vm.enterAddressManually();
                        } else {
                            if (data.Items.length === 0) {
                                vm.showNoResults = true;
                            } else {
                                vm.showEnterAddressManually = false;

                                const resp = data.Items[0];

                                vm.address.companyName = resp.Company;

                                if (resp.line3 !== '') {
                                    vm.address.line1 = resp.Line1;
                                    if (resp.Line2 !== '') {
                                        vm.address.line1 += ', ' + resp.Line2
                                    }
                                    vm.address.line2 = resp.Line3;
                                } else {
                                    vm.address.line1 = resp.Line1;
                                    vm.address.line2 = resp.Line2;
                                }

                                vm.address.city = resp.City;
                                vm.address.state = resp.AdminAreaName;
                                vm.address.postalCode = resp.PostalCode;
                                vm.address.countryId = vm.countries.find(x => x.name == resp.CountryName).countryId;

                                vm.enterAddressManually();
                            }
                        }
                    })
                    .catch(function (error) {
                        vm.enterAddressManually();
                        vm.addressApiError = true;
                    });
            });
        },
    },
    computed: {
        sortedAddress() {
            return this.addressLookupListSelect.sort((a, b) => {
                let textA = a.Text.toUpperCase(); // ignore case
                let textB = b.Text.toUpperCase(); // ignore case
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        },
    },
}
